export default __webpack_public_path__ + "static/media/value2.ff5e1501.svg";